import {useLocation} from "react-router-dom";
import {WritableError} from "types/operation";
import {ErrorType, UNKNOWN_ERROR} from "types/error";
import {MessageStatus} from "types/MessageStatus";
import {
  AppRouteUrlKey,
  ErrorPage as ErrorPageUI,
  TextType,
} from "@pinch-financial/pinch-ui-components";
import usePageText from "~/hooks/usePageText";

export interface LocationStateInterface {
  error: ErrorType;
}

const getMessageAndStatus = (error: ErrorType): MessageStatus => {
  let message: string = UNKNOWN_ERROR;
  let status: number | undefined = undefined;

  if (error) {
    if (typeof error === "string") {
      message = error;
    } else if (typeof error === "object") {
      // WritableError | ApiError
      const writableError = error as WritableError;
      if (typeof writableError?.message === "string") {
        message = writableError?.message;
      } else {
        message = writableError.message.message!;
      }

      message = message || UNKNOWN_ERROR;
      status = writableError.status;
    }
  }

  return [message, status];
};

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
}

const pageRoute: AppRouteUrlKey = "ERROR_PAGE_URL";
const ErrorPage = ({containerRef}: Props) => {
  const {getText, status: textStatus} = usePageText(pageRoute);

  const location = useLocation();
  const redirectState: ErrorType = location?.state;
  const [message, status] = getMessageAndStatus(redirectState);
  const title = [status, "Error"].filter(Boolean).join(" ");

  return (
    <ErrorPageUI
      loading={textStatus === "not-started" || textStatus === "pending"}
      containerRef={containerRef}
      title={getText(TextType.APP_PAGE_HEADER) ?? title}
      message={message}
    />
  );
};

export default ErrorPage;
